<button
  [disabled]="disabled"
  [type]="action !== 'remove' ? 'submit' : 'button'"
  pButton
  [label]="label"
  [raised]="raised"
  [text]="text"
  [outlined]="outlined"
  [icon]="icon"
  [class]="'p-button-rounded w-auto ' + cssClass"></button>
